// Library Class
import * as $ from 'jquery';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { CommonService } from './../../../../services/common/common.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { PlotSeedReleaseService } from '../../../../services/seed/plot-seed-release.service';
import { ToastrService } from 'ngx-toastr';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FilterComponent } from '../../../../common/components/filter/filter.component';

@Component({
  selector: 'app-plot-seed-release-review',
  templateUrl: './plot-seed-release-review.component.html',
  styleUrl: './plot-seed-release-review.component.scss',
  providers: [DecimalPipe]
})
export class PlotSeedReleaseReviewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(FilterComponent) filterComponent: FilterComponent;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  validateEvolveData: any;
  ddlAccounts: any[] = [];
  userMenuAccessList: any;
  readOnlyAccess = false;
  editFullAccess = false;
  filterOptionsData: Array<FilterOption>;
  showCreateButton = false;
  isEvolveAccountRestriction = false;
  subscription = new Subscription();
  masterConstants = MasterConstants;
  plotSeedDataSource: MatTableDataSource<any>;
  plotSeedReleaseDataSource: MatTableDataSource<any>;
  plotSeedReleaseErrorDataSource: MatTableDataSource<any>;
  @ViewChild('plotSeedTable', { read: MatSort }) plotSeedSort: MatSort;
  @ViewChild('plotSeedPaginator', { read: MatPaginator }) plotSeedPaginator: MatPaginator;
  @ViewChild('plotSeedReleaseTable', { read: MatSort }) plotSeedReleaseSort: MatSort;
  @ViewChild('plotSeedReleasePaginator', { read: MatPaginator }) plotSeedReleasePaginator: MatPaginator;
  @ViewChild('plotSeedReleaseErrorTable', { read: MatSort }) plotSeedReleaseErrorSort: MatSort;
  @ViewChild('plotSeedReleaseErrorPaginator', { read: MatPaginator }) plotSeedReleaseErrorPaginator: MatPaginator;
  plotSeedReleaseOrderColumns: string[] = ['releaseId', 'releaseItemId', 'releaseItemsLotsId', 'companyCode', 'jdeOrderNumber', 'jdeOrderType', 'jdeOrderLineNumber', 'customerPO', 'deliveryInstruction', 'webOrderNumber', 'freightHandlingCode', 'orderDate', 'requestedDate', 'accountNumber', 'accountName', 'city', 'state', 'deliverToAccountNumber', 'deliverToAccountName', 'itemId', 'itemNumber', 'itemDescription', 'hybridVariety', 'branchPlant', 'lotNumber', 'location', 'transactionUOM', 'transactionQuantity', 'createUser', 'createTimeStamp', 'updateUser', 'updateTimeStamp'];
  plotSeedReleaseJDESyncColumns: string[] = ['jdePlotSeedSyncId', 'companyCode', 'jdeOrderNumber', 'jdeOrderType', 'jdeOrderLineNumber', 'customerPO', 'deliveryInstruction1', 'deliveryInstruction2', 'webOrderNumber', 'webOrderNumberLineNumber', 'freightHandlingCode', 'orderDate', 'requestedDate', 'shipDate', 'invoiceDate', 'cropYear', 'accountNumber', 'accountName', 'city', 'state', 'deliverToAccountNumber', 'deliverToAccountName', 'itemId', 'itemNumber', 'itemDescription', 'hybridVariety', 'lastStatusCode', 'nextStatusCode', 'branchPlant', 'lotNumber', 'location', 'transactionUOM', 'transactionQuantity', 'orderLineStatusCode', 'jdeUpdateDate', 'jdeUpdateTime', 'createUser', 'createTimeStamp', 'updateUser', 'updateTimeStamp'];
  plotSeedReleaseErrorColumns: string[] = ['releaseErrorId', 'releaseId', 'messagePartSeq', 'releaseMessagePart', 'accountNumber', 'accountName', 'city', 'state', 'webOrderNumber', 'itemId', 'itemNumber', 'itemDescription', 'hybridVariety', 'lotNumber', 'location', 'transactionUOM', 'transactionQuantity', 'createUser', 'createTimeStamp', 'updateUser', 'updateTimeStamp'];
  filter: PlotSeedReleaseOrderFilterVM = new PlotSeedReleaseOrderFilterVM();
  orderTypeList: any = ['S6', 'ST'];
  orderLines: any;
  remainingQtyChk: boolean = false;
  hasOldFilter: Boolean = false;
  orderViewtoggle = false;
  tabIndex = 0;
  currentTab = 0;
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    public excelService: ExcelService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private plotSeedReleaseService: PlotSeedReleaseService
  ) { }

  // ngOnInit
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const sessionData = validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.editFullAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
          this.showCreateButton = this.editFullAccess;
          if (this.headerYear) {
            this.setFilterAndGridColumn();
            this.setDropDownValues();
            this.setDefaultFilter();
            const oldFilters = this.plotSeedReleaseService.getOldFilters();
            this.hasOldFilter = oldFilters != undefined || oldFilters != null;
            if (this.hasOldFilter) {
              Object.keys(oldFilters).forEach(key => {
                const value = oldFilters[key];

                if (value !== null && value !== undefined && value !== '') {
                  this.filter[key] = value;
                }
              });
            }
            this.plotSeedReleaseService.setOldFilters(null);
            this.setJDESyncDisplayColumns();
            this.getReleaseJDESyncData();
          }
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }
  }


  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setPlotSummaryTableHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setPlotSummaryTableHeight();
  }

  // set account table height
  setPlotSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - $('.plotSeedHeader').outerHeight() - $('.plotSeedFilterSection').outerHeight() - 130;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [

      { label: 'Account Number', key: 'accountNumberList', controlType: ControlType.Text },
      { label: 'Account Name', key: 'accountNameList', controlType: ControlType.Text },
      { label: 'Hybrid Varierty', key: 'brandList', controlType: ControlType.Text },
      { label: 'Lot Number', key: 'lotNumberList', controlType: ControlType.Text },
      { label: 'JDE Order Number', key: 'jdeOrderNumberList', controlType: ControlType.Text },
      { label: 'JDE Order Type', key: 'orderTypeCode', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: true },
      { label: 'Order Date', key: 'orderDate', controlType: ControlType.DateRange },
      { label: 'Web Order Number', key: 'orderNumberList', controlType: ControlType.Text }
    ];
  }

  setJDESyncDisplayColumns() {
    //this.plotSeedOrderColumns = ['jdePlotSeedSyncId', 'companyCode', 'jdeOrderNumber', 'jdeOrderType', 'jdeOrderLineNumber', 'customerPO', 'deliveryInstruction1', 'deliveryInstruction2', 'webOrderNumber', 'webOrderNumberLineNumber', 'freightHandlingCode', 'orderDate', 'requestedDate', 'shipDate', 'invoiceDate', 'cropYear', 'accountNumber', 'accountName', 'city', 'state', 'deliverToAccountNumber', 'deliverToAccountName', 'itemId', 'itemNumber', 'itemDescription', 'hybridVariety', 'lastStatusCode', 'nextStatusCode','branchPlant', 'lotNumber', 'location', 'transactionUOM', 'transactionQuantity', 'orderLineStatusCode', 'jdeUpdateDate', 'jdeUpdateTime', 'createUser', 'createTimeStamp', 'updateUser', 'updateTimeStamp'];
  }

  setReleaseDisplayColumns() {
    // this.plotSeedOrderColumns = ['releaseId', 'releaseItemId', 'releaseItemsLotsId', 'companyCode', 'jdeOrderNumber', 'jdeOrderType', 'jdeOrderLineNumber', 'customerPO', 'deliveryInstruction', 'webOrderNumber', 'freightHandlingCode', 'orderDate', 'requestedDate', 'accountNumber', 'accountName', 'city', 'state', 'deliverToAccountNumber', 'DeliverToAccountName', 'itemId', 'itemNumber', 'itemDescription', 'hybridVariety', 'branchPlant', 'lotNumber', 'location', 'transactionUOM', 'transactionQuantity', 'createUser', 'createTimeStamp', 'updateUser', 'updateTimeStamp'];
  }

  setReleaseErrorDisplayColumns() {
    // this.plotSeedOrderColumns = ['releaseErrorId', 'releaseId', 'messagePartSeq', 'releaseMessagePart', 'accountNumber', 'accountName', 'city', 'state', 'webOrderNumber', 'itemId'];
  }

  // Set Drop down values for filter
  setDropDownValues() {
    const orderTypes = [...new Set(this.orderTypeList)];

    this.filterOptionsData.find(x => x.key === 'orderTypeCode').controlData = orderTypes.map(status => ({
      id: status,
      value: status
    }));
    if (this.hasOldFilter) {
      this.filterOptionsData.find(x => x.key === 'lotNumberList').filterValue = this.filter.lotNumberList;
      this.filterOptionsData.find(x => x.key === 'jdeOrderNumberList').filterValue = this.filter.jdeOrderNumberList;
      this.filterOptionsData.find(x => x.key === 'accountNameList').filterValue = this.filter.accountNameList;
      this.filterOptionsData.find(x => x.key === 'accountNumberList').filterValue = this.filter.accountNumberList;
      this.filterOptionsData.find(x => x.key === 'orderNumberList').filterValue = this.filter.orderNumberList;
      this.filterOptionsData.find(x => x.key === 'brandList').filterValue = this.filter.brandList;

      if (this.filter.orderTypeCode) {
        this.filterOptionsData.find(x => x.key === 'orderTypeCode').filterValue = this.filter.orderTypeCode.split(',').map(s => s.trim());
      }

      this.filterOptionsData = [...this.filterOptionsData];
    }
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      orderNumberList: null,
      accountNumberList: null,
      accountNameList: null,
      jdeOrderNumberList: null,
      orderTypeCode: null,
      lotNumberList: null,
      brandList: null,
      orderDate: null
    };
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.tabIndex = tabChangeEvent.index;
    //this.filterComponent.clearAllFilterWithoutEmit();
    this.loadOrders();
  };

  getReleaseData() {
    var data = {
      lotNumberList: this.filter.lotNumberList,
      accountNumberList: this.filter.accountNumberList,
      accountNameList: this.filter.accountNameList,
      jdeOrderNumberList: this.filter.jdeOrderNumberList,
      jdeOrderTypeList: this.filter.orderTypeCode,
      orderNumberList: this.filter.orderNumberList,
      brandList: this.filter.brandList,
      orderDate: this.filter.orderDate
    };
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.plotSeedReleaseService.getReleaseOrderData(data).subscribe((result: any[]) => {
      const plotSeedOrderList = result && result.length > 0 ? result : [];
      this.plotSeedReleaseDataSource = new MatTableDataSource(plotSeedOrderList);

      this.plotSeedReleaseDataSource.paginator = this.plotSeedReleasePaginator;
      this.plotSeedReleaseDataSource.paginator.firstPage();
      this.plotSeedReleaseDataSource.sort = this.plotSeedReleaseSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  getReleaseJDESyncData() {
    var data = {
      lotNumberList: this.filter.lotNumberList,
      accountNumberList: this.filter.accountNumberList,
      accountNameList: this.filter.accountNameList,
      jdeOrderNumberList: this.filter.jdeOrderNumberList,
      jdeOrderTypeList: this.filter.orderTypeCode,
      orderNumberList: this.filter.orderNumberList,
      brandList: this.filter.brandList,
      orderDate: this.filter.orderDate
    };
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.plotSeedReleaseService.getPlotSeedReleaseJDESyncData(data).subscribe((result: any[]) => {
      const plotSeedOrderList = result && result.length > 0 ? result : [];
      this.plotSeedDataSource = new MatTableDataSource(plotSeedOrderList);

      this.plotSeedDataSource.paginator = this.plotSeedPaginator;
      this.plotSeedDataSource.paginator.firstPage();
      this.plotSeedDataSource.sort = this.plotSeedSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  getReleaseErrorData() {
    var data = {
      lotNumberList: this.filter.lotNumberList,
      accountNumberList: this.filter.accountNumberList,
      accountNameList: this.filter.accountNameList,
      jdeOrderNumberList: null,
      jdeOrderTypeList: null,
      orderNumberList: this.filter.orderNumberList,
      brandList: this.filter.brandList,
      orderDate: this.filter.orderDate
    };
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.plotSeedReleaseService.getReleaseOrderErrorData(data).subscribe((result: any[]) => {
      const plotSeedOrderList = result && result.length > 0 ? result : [];
      this.plotSeedReleaseErrorDataSource = new MatTableDataSource(plotSeedOrderList);

      this.plotSeedReleaseErrorDataSource.paginator = this.plotSeedReleaseErrorPaginator;
      this.plotSeedReleaseErrorDataSource.paginator.firstPage();
      this.plotSeedReleaseErrorDataSource.sort = this.plotSeedReleaseErrorSort
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.loadOrders();
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.loadOrders();
  }

  clearAllFilter() {
    this.setFilterAndGridColumn();
    this.setDefaultFilter();
    this.setDropDownValues();
  }

  navigateToReleaseLanding() {
    this.router.navigate(['/plot-seed/plot-seed-release-landing']);
  }

  loadOrders() {
    this.setPlotSummaryTableHeight();
    if (this.tabIndex == 0) {
      this.getReleaseJDESyncData();
    }
    else if (this.tabIndex == 1) {
      this.getReleaseData();
    }
    else {
      this.getReleaseErrorData();
    }
  }

  public export() {
    var data = {
      lotNumberList: this.filter.lotNumberList,
      accountNumberList: this.filter.accountNumberList,
      accountNameList: this.filter.accountNameList,
      jdeOrderNumberList: this.filter.jdeOrderNumberList,
      jdeOrderTypeList: this.filter.orderTypeCode,
      orderNumberList: this.filter.orderNumberList,
      brandList: this.filter.brandList,
      orderDate: this.filter.orderDate
    };
    this.loaderService.setLoaderStatus(true); // Show loader immediately

    this.subscription.add(this.plotSeedReleaseService.exportReviewRelease(data)
      .subscribe(
        (result) => {
          if (result) {
            this.plotSeedReleaseService.base64toFile(result.base64, result.mimeType, result.fileName);
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error("An error occurred during export.");
          }
        },
        (error) => this.toastrService.error("An error occurred during export.")
      ));
  }

}

export class PlotSeedReleaseOrderFilterVM {
  orderNumberList: string;
  accountNumberList: number;
  accountNameList: any;
  brandList: string;
  lotNumberList: string;
  jdeOrderNumberList: number;
  orderTypeCode: string;
  orderDate: string;
}
